import { Routes } from '@angular/router';
import { AzgivComponent } from './components/azgiv/azgiv.component';
import { DashboardMainComponent } from './components/content-dashboard/dashboard-main.component';
import { ContentJobsComponent } from './components/content-jobs/content-jobs.component';
import { JobsAddFilesComponent } from './components/content-jobs/jobs-add-files/jobs-add-files.component';
import { JobsFieldMappingComponent } from './components/content-jobs/jobs-field-mapping/jobs-field-mapping.component';
import { JobsUploadLogsComponent } from './components/content-jobs/jobs-upload-logs/jobs-upload-logs.component';
import { JobsBuildtopoLogsComponent } from './components/content-jobs/jobs-buildtopo-logs/jobs-buildtopo-logs.component';
import { JobsQcLogsComponent } from './components/content-jobs/jobs-qc-logs/jobs-qc-logs.component';
// import { ContentUserAdminComponent } from './components/content-user-admin/content-user-admin.component';
import { UserAdminDataComponent } from './components/content-user-admin/user-admin-data/user-admin-data.component';
import { ContentUserGuideComponent } from './components/content-user-guide/content-user-guide.component';
import { LoginComponent } from './components/auth/login/login.component';
import { LoginAzComponent } from './components/auth/login-az/login-az.component';
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { AdminGuardService as AdminGuard } from './services/admin-guard.service';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { PublishLayerGuard } from './guards/publish-layer.guard';
import { GuardConfigIntegratorService as ConfigIntegratorGuard } from './services/guard-config-integrator.service';
// import { ResolverLayersService } from './services/resolver-layers.service';
import { ResolverJobsTransactionsService } from './services/resolver-jobs-transactions.service';
import { AppSettings } from './app.settings';
import { ConfigUsersComponent } from './components/content-config/config-users/config-users.component';
import { ConfigSubAgenciesComponent } from './components/content-config/config-sub-agencies/config-sub-agencies.component';
import { UserVerifyComponent } from './components/auth/user-verify/user-verify.component';
import { ConfigIntegratorsComponent } from './components/content-config/config-integrators/config-integrators.component';
import { ConfigNagComponent } from './components/content-config/config-nag/config-nag.component';
import { ContentLayersComponent } from './components/content-layers/content-layers.component';
import { LayerComplexComponent } from './components/content-layers/layer-complex/layer-complex.component';
import { ContentReportsComponent } from './components/content-reports/content-reports.component';
import { TestComponent } from './components/test/test.component';
import { ConfigAgencyProfileComponent } from './components/content-config/config-agency-profile/config-agency-profile.component';
import { ResolverGiveInitService } from './services/resolver-give-init.service';
// Get login component according to portal
export function getLoginComponent() {
    return (function () {
        switch (AppSettings.loginPortal) {
            case 'AZPortal':
                return LoginAzComponent;
            case 'LBPortal':
            default:
                return LoginComponent;
        }
    })();
}
var ɵ0 = { stateName: 'azgiv' }, ɵ1 = { stateName: 'dashboard' }, ɵ2 = { content: 'live' }, ɵ3 = { content: 'interlayers' }, ɵ4 = { content: 'published' }, ɵ5 = { content: 'report' }, ɵ6 = { stateName: 'jobs' }, ɵ7 = { stateName: 'jobsaddfiles' }, ɵ8 = { stateName: 'jobsfieldmapping' }, ɵ9 = { stateName: 'jobsuploadlogs' }, ɵ10 = { stateName: 'jobsqclogs' }, ɵ11 = { stateName: 'JobsTopoLogsComponent' }, ɵ12 = { stateName: 'data' }, ɵ13 = { stateName: 'userguide' }, ɵ14 = { stateName: 'auth' }, ɵ15 = { stateName: 'login' }, ɵ16 = { stateName: 'main' };
// stateName is required in data property for each Route, which has to be unique
var appRoutes = [
    //
    {
        path: 'azgiv',
        component: AzgivComponent,
        data: ɵ0,
        canActivate: [AuthGuard],
        resolve: {
            giveInitResolve: ResolverGiveInitService,
        },
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            // Dashboards
            {
                path: 'dashboard',
                component: DashboardMainComponent,
                data: ɵ1,
                resolve: {
                    // layers: ResolverLayersService, 
                    transactionInfo: ResolverJobsTransactionsService
                }
            },
            // Layers and Data
            {
                path: 'layers',
                component: ContentLayersComponent,
                // resolve: { layers: ResolverLayersService },
                children: [
                    { path: '', redirectTo: 'live-layers', pathMatch: 'full' },
                    { path: 'live-layers', redirectTo: 'live-layers/' },
                    {
                        path: 'live-layers/:layerId',
                        component: LayerComplexComponent,
                        data: ɵ2,
                        canDeactivate: [PendingChangesGuard]
                    },
                    { path: 'interlayers', redirectTo: 'interlayers/' },
                    {
                        path: 'interlayers/:layerId',
                        component: LayerComplexComponent,
                        data: ɵ3,
                        canDeactivate: [PendingChangesGuard]
                    },
                    { path: 'published-layers', redirectTo: 'published-layers/' },
                    {
                        path: 'published-layers/:layerId',
                        component: LayerComplexComponent,
                        data: ɵ4,
                        canDeactivate: [PendingChangesGuard],
                        canActivate: [PublishLayerGuard]
                    },
                    { path: 'reports', redirectTo: 'reports/' },
                    {
                        path: 'reports/:layerId',
                        component: ContentReportsComponent,
                        data: ɵ5,
                    },
                ]
            },
            // Jobs: upload files
            {
                path: 'jobs',
                component: ContentJobsComponent,
                data: ɵ6,
                // resolve: { layers: ResolverLayersService },
                children: [
                    { path: '', redirectTo: 'add-files', pathMatch: 'full' },
                    // {
                    // 	path: 'summary',
                    // 	component: JobsSummaryComponent,
                    // 	data: { stateName: 'jobssummary'},
                    // 	resolve: { transactionInfo: ResolverJobsTransactionsService }
                    // },
                    {
                        path: 'add-files',
                        component: JobsAddFilesComponent,
                        data: ɵ7,
                    }, {
                        path: 'field-mapping',
                        component: JobsFieldMappingComponent,
                        data: ɵ8
                    }, {
                        path: 'upload-logs',
                        component: JobsUploadLogsComponent,
                        data: ɵ9,
                    },
                    {
                        path: 'qc-logs',
                        component: JobsQcLogsComponent,
                        data: ɵ10,
                    }, {
                        path: 'topo-logs',
                        component: JobsBuildtopoLogsComponent,
                        data: ɵ11
                    }
                ]
            },
            // {
            // 	path: 'user-admin',
            // 	component: ContentUserAdminComponent,
            // 	data: { stateName: 'useradmin'}
            // },
            // TODO: currently on way on ui that can go to this component
            {
                path: 'data',
                component: UserAdminDataComponent,
                data: ɵ12
            },
            // Configs
            {
                path: 'config',
                canActivate: [AdminGuard],
                children: [
                    { path: '', redirectTo: 'users', pathMatch: 'full' },
                    { path: 'users', component: ConfigUsersComponent },
                    { path: 'agency-profile', component: ConfigAgencyProfileComponent },
                    { path: 'sub-agencies', component: ConfigSubAgenciesComponent },
                    { path: 'integrators', component: ConfigIntegratorsComponent, canActivate: [ConfigIntegratorGuard] },
                    { path: 'nag', component: ConfigNagComponent }
                ]
            },
            // User Guide
            {
                path: 'user-guide',
                component: ContentUserGuideComponent,
                data: ɵ13
            }, {
                path: '123test',
                component: TestComponent
            }
        ]
    },
    // Authentication
    { path: 'auth', data: ɵ14, children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            {
                path: 'login',
                component: AppSettings.loginPortal === 'AZPortal' ? LoginAzComponent : LoginComponent,
                data: ɵ15
            },
            {
                path: 'verify',
                component: UserVerifyComponent
            }
        ] },
    // Main state
    { path: '', redirectTo: '/azgiv/dashboard', pathMatch: 'full', data: ɵ16 }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16 };
